/* eslint-disable no-fallthrough */
import { actionTypes } from "./roomActions";

const {
  ROOM_PENDING,
  ROOM_SUCCESS,
  ROOM_ERROR,

  ROOM_ADD_PENDING,
  ROOM_ADD_SUCCESS,
  ROOM_ADD_ERROR,

  ROOM_EDIT_PENDING,
  ROOM_EDIT_SUCCESS,
  ROOM_EDIT_ERROR,

  BOOK_ROOM_PENDING,
  BOOK_ROOM_SUCCESS,
  BOOK_ROOM_ERROR,

  CHECKOUT_ROOM_PENDING,
  CHECKOUT_ROOM_SUCCESS,
  CHECKOUT_ROOM_ERROR,

  OCCUPANCY_HISTORY_PENDING,
  OCCUPANCY_HISTORY_SUCCESS,
  OCCUPANCY_HISTORY_ERROR,

  OCCUPANCY_CHECK_PENDING,
  OCCUPANCY_CHECK_SUCCESS,
  OCCUPANCY_CHECK_ERROR,

  CURRENT_OCCUPANCY_PENDING,
  CURRENT_OCCUPANCY_SUCCESS,
  CURRENT_OCCUPANCY_ERROR,

  ROOM_ARCHIVE_PENDING,
  ROOM_ARCHIVE_SUCCESS,
  ROOM_ARCHIVE_ERROR,

  CANCEL_BOOKING_PENDING,
  CANCEL_BOOKING_SUCCESS,
  CANCEL_BOOKING_ERROR,

  SET_ACTIVE_MEETING_ROOMS_TAB,
  SET_ROOM_MANAGEMENT_PAGE,
  SET_OCCUPANCY_HISTORY_PAGE,
  SET_MY_OCCUPANCY_PAGE,
  SET_MY_OCCUPANCY_FILTERS,
  SET_OCCUPANCY_HISTORY_FILTERS,
  CLEAR_ROOM_PAGINATION_STATE,
} = actionTypes;

const initialState = {
  roomPending: false,
  roomSuccess: false,
  roomError: null,
  roomList: [],
  roomPagination: null,

  roomAddPending: false,
  roomAddSuccess: false,
  roomAddError: null,

  roomEditPending: false,
  roomEditSuccess: false,
  roomEditError: null,

  activeMeetingRoomsTab: sessionStorage.getItem("activeMeetingRoomsTab") || "status",
  roomManagementPage: Number(sessionStorage.getItem("roomManagementPage")) || 1,
  occupancyHistoryPage: Number(sessionStorage.getItem("occupancyHistoryPage")) || 1,
  myOccupancyPage: Number(sessionStorage.getItem("myOccupancyPage")) || 1,
  myOccupancySelectedDate: sessionStorage.getItem("myOccupancySelectedDate") || null,
  occupancyHistoryFilters: sessionStorage.getItem("occupancyHistoryFilters") ? JSON.parse(sessionStorage.getItem("occupancyHistoryFilters")) : {
    roomId: "",
    location: "",
    fromDate: null,
    toDate: null,
  },

  bookPending: false,
  bookSuccess: false,
  bookError: null,
  bookingResult: null,

  checkoutPending: false,
  checkoutSuccess: false,
  checkoutError: null,

  occupancyHistoryPending: false,
  occupancyHistorySuccess: false,
  occupancyHistoryError: null,
  occupancyHistoryList: [],
  occupancyHistoryPagination: null,

  occupancyCheckPending: false,
  occupancyCheckSuccess: false,
  occupancyCheckError: null,
  occupancyCheckResult: null,

  currentOccupancyPending: false,
  currentOccupancySuccess: false,
  currentOccupancyError: null,
  currentOccupancyList: [],

  roomArchivePending: false,
  roomArchiveSuccess: false,
  roomArchiveError: null,

  cancelBookingPending: false,
  cancelBookingSuccess: false,
  cancelBookingError: null,
};

export default function room(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ROOM_PENDING:
    case ROOM_SUCCESS:
    case ROOM_ERROR:
    case ROOM_ADD_PENDING:
    case ROOM_ADD_SUCCESS:
    case ROOM_ADD_ERROR:
    case ROOM_EDIT_PENDING:
    case ROOM_EDIT_SUCCESS:
    case ROOM_EDIT_ERROR:
    case BOOK_ROOM_PENDING:
    case BOOK_ROOM_SUCCESS:
    case BOOK_ROOM_ERROR:
    case CHECKOUT_ROOM_PENDING:
    case CHECKOUT_ROOM_SUCCESS:
    case CHECKOUT_ROOM_ERROR:
    case OCCUPANCY_HISTORY_PENDING:
    case OCCUPANCY_HISTORY_SUCCESS:
    case OCCUPANCY_HISTORY_ERROR:
    case OCCUPANCY_CHECK_PENDING:
    case OCCUPANCY_CHECK_SUCCESS:
    case OCCUPANCY_CHECK_ERROR:
    case CURRENT_OCCUPANCY_PENDING:
    case CURRENT_OCCUPANCY_SUCCESS:
    case CURRENT_OCCUPANCY_ERROR:
    case ROOM_ARCHIVE_PENDING:
    case ROOM_ARCHIVE_SUCCESS:
    case ROOM_ARCHIVE_ERROR:
    case CANCEL_BOOKING_PENDING:
    case CANCEL_BOOKING_SUCCESS:
    case CANCEL_BOOKING_ERROR:
      return Object.assign({}, state, payload);

    case SET_ACTIVE_MEETING_ROOMS_TAB:
      return Object.assign({}, state, { activeMeetingRoomsTab: payload });

    case SET_ROOM_MANAGEMENT_PAGE:
      return Object.assign({}, state, { roomManagementPage: payload });

    case SET_OCCUPANCY_HISTORY_PAGE:
      return Object.assign({}, state, { occupancyHistoryPage: payload });

    case SET_MY_OCCUPANCY_PAGE:
      return Object.assign({}, state, { myOccupancyPage: payload });

    case SET_MY_OCCUPANCY_FILTERS:
      return Object.assign({}, state, { myOccupancySelectedDate: payload });

    case SET_OCCUPANCY_HISTORY_FILTERS:
      return Object.assign({}, state, { occupancyHistoryFilters: payload });

    case CLEAR_ROOM_PAGINATION_STATE:
      return Object.assign({}, state, {
        activeMeetingRoomsTab: "status",
        roomManagementPage: 1,
        occupancyHistoryPage: 1,
        myOccupancyPage: 1,
        myOccupancySelectedDate: null,
        occupancyHistoryFilters: {
          roomId: "",
          location: "",
          fromDate: null,
          toDate: null,
        },
      });

    default:
      return state;
  }
}
